

































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { formatCouponDate, formatCouponText, formatNumber, isMobile } from '@/utils/helpers';
import constants from '@/utils/constants';
import CouponModal from '../CouponModal/CouponModal.vue';
import './style.scss';

@Component({
  filters: {
    formatDate(val: any) {
      return formatCouponDate(val);
    }
  },
  components: {
    CouponModal
  }
})
export default class DiscountModal extends Vue {
  @Prop() show!: boolean;
  @Prop() item!: any;
  @Prop() hideDiscount!: Function;
  @Prop() updateDiscount!: Function;
  $swal: any;
  constants: any = constants;
  showDiscountModal: boolean = true;
  showDiscountChannel: boolean = false;
  showCouponModal: boolean = false;
  promo_type: number = this.item.promo_type;
  promo_value: number = this.item.promo_value;
  free_promo_value: number = 0;
  discount_name: string = this.item.discount_name;
  coupon: any = {};
  discountOptions: Array<any> = [
    { value: 10000, text: 'Rp. 10.000', disabled: false },
    { value: 30000, text: 'Rp. 30.000', disabled: false },
    { value: 50000, text: 'Rp. 50.000', disabled: false },
    { value: 75000, text: 'Rp. 75.000', disabled: false },
    { value: 100000, text: 'Rp. 100.000', disabled: false },
    { value: 150000, text: 'Rp. 150.000', disabled: false },
    { value: 200000, text: 'Rp. 200.000', disabled: false },
    { value: 250000, text: 'Rp. 250.000', disabled: false },
  ];
  public formatCouponText: Function = formatCouponText;

  formatPrice(val: any) {
    let date: any = val;
    return formatNumber(date);
  }
  showDiscountModalHandle() {
    this.showDiscountModal = true;
  }
  hideDiscountModalHandle() {
    this.showDiscountModal = false;
    if (!this.showDiscountChannel && !this.showCouponModal) {
      this.hideDiscount();
    }
  }
  showDiscountChannelHandle() {
    this.showDiscountChannel = true;
    this.showDiscountModal = false;
  }
  hideDiscountChannelHandle() {
    this.showDiscountChannel = false;
    this.showDiscountModalHandle();
  }
  showCouponModalHandle() {
    this.showCouponModal = true;
    this.showDiscountModal = false;
  }
  hideCouponHandle() {
    this.showCouponModal = false;
    this.showDiscountModalHandle();
  }
  setCouponHandle(item) {
    this.coupon = item;
    this.hideCouponHandle();
  }
  changeDiscount(event) {
    const validateValue = this.promo_type === 0 ? 100 : Infinity;
    if (isNaN(event) || Number(event) < 0 || Number(event) > validateValue) {
      return (this.promo_value = 0);
    }
    this.promo_value = event;
  }
  selectDiscount(event) {
    this.promo_value = event;
    this.hideDiscountChannelHandle();
    this.free_promo_value = 0;
  }
  changeFreeInputPromoValue(value) {
    this.promo_value = 0;
    this.free_promo_value = Number(value);
  }
  okHandle() {
    if (
      this.promo_type !== 2 &&
      ((this.promo_value && !this.discount_name) ||
        (this.free_promo_value && !this.discount_name))
    ) {
      return this.$swal(
        constants.SOMETHING_WROING,
        'The Discount Name is required',
        constants.STATUS_ERROR
      );
    }
    this.showDiscountModal = false;
    this.updateDiscount({
      promo_type: this.promo_type,
      coupon: this.coupon,
      promo_value: Number(this.free_promo_value || this.promo_value),
      discount_name: this.discount_name
    });
  }
  promoValueFocus() {
    if (isMobile()) {
      (this.$refs as any).discountChannelShade.style = 'z-index: 20;';
      (this.$refs as any).discountChannel.style = 'transform: translate(-50%, 0) scale(1.3); top: unset; bottom: 55px; z-index: 21;';
    }
  }
  promoValueBlur() {
    if (isMobile()) {
      (this.$refs as any).discountChannelShade.style = '';
      (this.$refs as any).discountChannel.style = '';
    }
  }

  @Watch('promo_type')
  watchPromoType() {
    this.promo_value = 0;
    this.free_promo_value = 0;
    this.coupon = {};
  }

  mounted() {
    if (this.item.coupon_list && this.item.promo_id) {
      const filterCoupon = this.item.coupon_list.result.filter((item: any) => item.id === this.item.promo_id);
      if (filterCoupon.length) {
        this.coupon = filterCoupon[0];
      }
    }
    for (let i = 0; i < this.discountOptions.length; i++) {
      const element = this.discountOptions[i];
      element.disabled = element.value > this.item.billing_total_amount;
    }
    const filterOptions = this.discountOptions.filter((item: any) => item.value === this.item.promo_value);
    if (this.item.promo_type === 1 && !filterOptions.length) {
      this.free_promo_value = this.item.promo_value;
    }
  }
}
